import { render, staticRenderFns } from "./Infosucc.vue?vue&type=template&id=15db4ee9&scoped=true&"
import script from "./Infosucc.vue?vue&type=script&lang=ts&"
export * from "./Infosucc.vue?vue&type=script&lang=ts&"
import style0 from "./Infosucc.vue?vue&type=style&index=0&id=15db4ee9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db4ee9",
  null
  
)

export default component.exports